import { APIMethod, fetchData } from "@client";

export async function updateLabelGroupQuery(
  id,
  group,
) {
  const res = await fetchData(
    `/v1/labels/${id}`,
    APIMethod.PUT,
    {
      data: {
        group,
      }
    }
  );
  return res.results;
}